// @flow
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './WhiteLabelCrown.module.scss';

type Props = {|
    siteName: string,
    siteUrl: string,
|};

const WhiteLabelCrown = ({ siteName, siteUrl }: Props) => {
    return (
        <div className={styles.crown}>
            <div className={styles['crown-inner']}>
                {siteUrl.length > 0 && (
                    <Link secondary to={siteUrl}>
                        <FormattedMessage id="return_to" values={{ name: siteName }} />
                    </Link>
                )}
            </div>
        </div>
    );
};

export default React.memo<Props>(WhiteLabelCrown);
